import styled from "styled-components";
import { visuallyHidden } from "@sproutsocial/seeds-react-mixins";
import type { ComponentPropsWithRef } from "react";

const StyledVisuallyHidden = styled.span`
  ${visuallyHidden}
`;

export type VisuallyHiddenProps = ComponentPropsWithRef<
  typeof StyledVisuallyHidden
>;

export const VisuallyHiddenStyled = (props: VisuallyHiddenProps) => (
  <StyledVisuallyHidden {...props} />
);
